import type { ReactElement } from 'react';

export const Placeholder = (): ReactElement => <></>;
